<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="years">
<h1>40 Years</h1>
<p style="text-indent: 00em;">’Twas 40 years ago I said</p>
<p style="text-indent: 00em;">To Ken, I think it’s time we wed</p>
<p style="text-indent: 00em;">We’d lived together 3 years or so</p>
<p style="text-indent: 00em;">And if I’d left it up to him, I know</p>
<p style="text-indent: 00em;">We would still be in that same place</p>
<p style="text-indent: 00em;">And I would not have had a happy face</p><br/>
<p style="text-indent: 00em;">So, take Friday off, as work’s a bit slow</p>
<p style="text-indent: 00em;">And down to the registry office we will go</p>
<p style="text-indent: 00em;">No one knew what we did that day</p>
<p style="text-indent: 00em;">And when we rang the families, they were all away</p><br/>
<p style="text-indent: 00em;">We went to the Pizza Hut for our wedding feast</p>
<p style="text-indent: 00em;">And we had pizza and a carafe of wine at least</p>
<p style="text-indent: 00em;">So happy we were when we went back to our home</p>
<p style="text-indent: 00em;">The families we tried again to phone</p>
<p style="text-indent: 00em;">Oh well! They would find out in due course</p>
<p style="text-indent: 00em;">As we knew this one wouldn’t end in divorce</p>
<p style="text-indent: 00em;">Still happy and smiling we are to this day</p>
<p style="text-indent: 00em;">And I’m sure to the end it will stay this way</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch014.vue?03fb51f6